import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  HelperFunctionsService,
  MinimumStockService,
} from '@boma/supplier-portal/shared/services';
import { StockRuleType } from 'libs/supplier-portal/shared/entities/src/lib/enums/stock-rule-type.enum';

@Component({
  selector: 'boma-stock-rules',
  templateUrl: './stock-rules.component.html',
  styleUrls: ['./stock-rules.component.scss'],
})
export class StockRulesComponent implements OnInit {
  @Input() locationIds: string[] = [];
  @Input() organizationId: string;

  selectedLocations: any;

  stockRules: any;
  isCustomValue: boolean = false;
  selectedValue: number | null = null;
  selectedProduct: any;
  showLocationsBar: boolean = false;
  columns = [
    {
      field: 'product',
      header: 'Product Name',
      converter: (val) => {
        return val?.name;
      },
    },
    { field: 'value', type: 'number', header: 'Min Stock' },

    {
      field: 'createdAt',
      header: 'Created At',
      converter: (val) => this.helperService.friendlyDate(val),
    },
    {
      field: 'updatedAt',
      header: 'Updated At',
      converter: (val) => this.helperService.friendlyDate(val),
    },
    { field: 'actions', header: '' },
  ];

  createFormGroup: FormGroup;

  constructor(
    private minimumStockService: MinimumStockService,
    private helperService: HelperFunctionsService
  ) {
    this.createFormGroup = new FormGroup({
      entityId: new FormControl(this.organizationId, Validators.required),
      productId: new FormControl('', Validators.required),
      locationId: new FormControl(''),
      ruleType: new FormControl(
        StockRuleType.MinimumStock,
        Validators.required
      ),
      value: new FormControl(0, [Validators.required]),
      applyToAllLocations: new FormControl(false),
    });
  }
  ngOnInit(): void {
    if (this.locationIds.length > 0) {
      this.createFormGroup.patchValue({
        locationId: this.locationIds[0],
      });
    } else {
      this.createFormGroup.patchValue({
        applyToAllLocations: true,
      });
      this.showLocationsBar = true;
      this.columns.splice(1, 0, {
        field: 'location',
        header: 'Location',
        converter: (val) => {
          return val?.name || 'All Locations';
        },
      });
    }

    this.minimumStockService
      .getMinimumStockRules(this.organizationId, 1, 100, [], this.locationIds)
      .subscribe((res) => {
        this.stockRules = res;
      });

    //the constructor is not working with this so Ill just do it here again
    if (this.organizationId) {
      this.createFormGroup.patchValue({
        entityId: this.organizationId,
      });
    }
  }

  createStockRule() {
    if (this.createFormGroup.value.applyToAllLocations) {
      this.createFormGroup.patchValue({
        locationId: null,
      });
    }

    if (this.createFormGroup.valid) {
      const formData = this.createFormGroup.value;
      this.minimumStockService
        .createProductStockRule(
          formData.entityId,
          formData.ruleType,
          formData.productId,
          formData.value,
          formData.locationId
        )
        .subscribe((res) => {
          this.stockRules.items.push(res);
          this.createFormGroup.get('productId').reset();
          this.selectedProduct = null;
        });
    } else {
      console.log('Form is invalid');
    }
  }

  onDeleted(ev) {
    this.minimumStockService
      .deleteProductStockRule(this.organizationId, ev.id)
      .subscribe((res) => {
        //need to update the data we have
        this.stockRules.items = this.stockRules.items.filter(
          (x) => x.id !== ev.id
        );
      });
  }

  setValue(value: number): void {
    this.isCustomValue = false;
    this.selectedValue = value;
    this.createFormGroup.get('value').setValue(value);
  }

  setCustomValue(): void {
    this.isCustomValue = true;
    this.selectedValue = null;
    this.createFormGroup.get('value').setValue(null);
  }

  handleProductsSelection(ev) {
    this.selectedProduct = ev[0];
    this.createFormGroup.patchValue({
      productId: ev[0]?.id || null,
    });
  }

  locationHandler(event) {
    this.selectedLocations = event;
    this.createFormGroup.patchValue({
      locationId: this.selectedLocations[0]?.id,
      applyToAllLocations: false,
    });
  }
}
